/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Upkeep_Title6Inputs */

const en_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation upkeep`)
};

const ar_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صيانة الأتمتة`)
};

const bn_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোমেশন রক্ষণাবেক্ষণ`)
};

const de_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierungspflege`)
};

const es_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenimiento de automatizaciones`)
};

const fr_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entretien des automatisations`)
};

const pt_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manutenção de automações`)
};

const zh_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动化运维`)
};

const tr_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomasyon bakımı`)
};

const ru_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка автоматизаций`)
};

const pl_svc_retainer_upkeep_title6 = /** @type {(inputs: Svc_Retainer_Upkeep_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utrzymanie automatyzacji`)
};

/**
* | output |
* | --- |
* | "Automation upkeep" |
*
* @param {Svc_Retainer_Upkeep_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_upkeep_title6 = /** @type {((inputs?: Svc_Retainer_Upkeep_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Upkeep_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_upkeep_title6(inputs)
	if (locale === "bn") return bn_svc_retainer_upkeep_title6(inputs)
	if (locale === "de") return de_svc_retainer_upkeep_title6(inputs)
	if (locale === "es") return es_svc_retainer_upkeep_title6(inputs)
	if (locale === "fr") return fr_svc_retainer_upkeep_title6(inputs)
	if (locale === "pt") return pt_svc_retainer_upkeep_title6(inputs)
	if (locale === "zh") return zh_svc_retainer_upkeep_title6(inputs)
	if (locale === "tr") return tr_svc_retainer_upkeep_title6(inputs)
	if (locale === "ru") return ru_svc_retainer_upkeep_title6(inputs)
	if (locale === "pl") return pl_svc_retainer_upkeep_title6(inputs)
	return en_svc_retainer_upkeep_title6(inputs)
});
export { svc_retainer_upkeep_title6 as "svc_retainer_UPKEEP_title" }